module.exports = __webpack_public_path__ + "img/logo_facebook_pixel.16ca007e.svg";